import { render, staticRenderFns } from "./vipBox.vue?vue&type=template&id=54c0fef4&scoped=true&"
import script from "./vipBox.vue?vue&type=script&lang=js&"
export * from "./vipBox.vue?vue&type=script&lang=js&"
import style0 from "./vipBox.vue?vue&type=style&index=0&id=54c0fef4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c0fef4",
  null
  
)

export default component.exports